import script from "./ReportIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportIndex.vue?vue&type=script&setup=true&lang=js"

import "./ReportIndex.vue?vue&type=style&index=0&id=21de36d7&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21de36d7"]])

export default __exports__